module.exports = __webpack_public_path__ + "static/media/muli-latin-900italic.3b4a9a0e.woff";